import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'reactstrap';

import { IButtonProps } from 'types/components/buttons';
import { buildUrl, s } from 'utilities/strings';

const LoginButton: FC<IButtonProps> = ({ replace = true, state }) => {
  const navigate = useNavigate();
  const handleClick = useCallback(
    () =>
      navigate(buildUrl('Root.children.Login'), {
        replace,
        state,
      }),
    [navigate, replace, state]
  );

  return (
    <Button
      color="primary"
      onClick={handleClick}>
      {s('Site.BackToLogin')}
    </Button>
  );
};

export default LoginButton;
